module.exports = __webpack_public_path__ + "static/img/boothStep4.5484caf1.jpg";